import styled from 'styled-components';
import { colors } from '../../../styles/colors';

export const FormWrapper = styled.div`
  padding: 0;
  width: auto;
  height: auto;
  background: transparent;
  border: none;
  margin-bottom: 28px;
  position: relative;
  display: flex;
`;

export const Label = styled.label`
  font-size: 14px;
  color: ${colors.text3};
  display: block;
  font-weight: 500;
  margin-bottom: 0;
  cursor: pointer;
`;

export const InputCheck = styled.input`
  border: 2px solid ${colors.border3};
  appearance: none;
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin-right: 6px;
  position: relative;
  top: 4px;

  &:focus {
    outline: none;
  }

  &:checked {
    background-color: ${colors.blue2};
    background: ${colors.blue2}
      url('data:image/gif;base64,R0lGODlhCwAKAIABAP////3cnSH5BAEKAAEALAAAAAALAAoAAAIUjH+AC73WHIsw0UCjglraO20PNhYAOw==')
      2px 2px no-repeat;
    border-color: ${colors.blue2};
  }
`;
